import React, { useState } from 'react';
import AppContext, { IAppContext } from '.';
import * as utils from '../utils';
import { SmartAgent } from '@missionlabs/smartagent-app-components';

interface Props {
    facia: string;
    token: string;
    children: React.ReactNode;
    sm: SmartAgent
}

const CartProvider: React.FC<Props> = ({ children, facia, token, sm }) => {

    const [contactID, setContactID] = useState<string>()
    const getInitialContactID = async (): Promise<string> => {
        const contactID =  await sm._listenForMessage('get_initial_contact_id')
        setContactID(contactID)
        return contactID
    }

    const updateCart = async (id: string) => {
        console.log("updating cart context...")
        const response = await utils.getCart(id, token, facia);

        setCtx(ctx => ({
            ...ctx,
            cart: response.data,
            cartID: id,
        }))

    }

    const startPayment = async (cartID: string) => {

        try {
            setCtx(ctx => ({
                ...ctx,
                isPaying: true,
                error: '',
                transferSuccessful:false
            }))

            const cart = await utils.getCart(cartID, token, facia);
            if (cart.status === 200) {
                if (!cart.data.progress.hasBillingAddress) {
                    return setCtx(ctx => ({
                        ...ctx,
                        cart: cart.data,
                        error: "No billing address has been entered, proceed to a payment option and try again.",
                        isPaying: false,
                        transferSuccessful:false
                    }))
                }
            }

            // Make sure to fetch the initial contact ID for the current contact.
            const initialContactID = await getInitialContactID()
            const response = await utils.startPayment(cartID, initialContactID, token, facia);

            if (response.status === 200) {

                sm.sendMessage("quick_connect", {
                    name: "SmartPCI Secure Payment"
                })

                setCtx(ctx => ({
                    ...ctx,
                    paymentProgress: undefined,
                    state: "paying",
                    isPaying: false,
                    transferSuccessful: true
                }))

            }
            
        } catch (e) {
            setCtx(ctx => ({
                ...ctx,
                isPaying: false,
                error: "Something went wrong while starting your payment. Please try again or contact support if the issue persists."
            }))
        }
    }

    const completePayment = async (paymentReference?: string) => {

        const thisContactID = contactID ?? await getInitialContactID()
        const response = await utils.completePayment(ctx.cartID!, thisContactID, token, facia, paymentReference);

        if (response.status === 200) {
            setCtx(ctx => ({
                ...ctx,
                order: response.data,
                state: "finished"
            }))
        }

    }

    const updatePaymentProgress = async () => {
        console.log("polling payment progress")
        const thisContactID = contactID ?? await getInitialContactID()
        const response = await utils.getPaymentStatus(thisContactID, token);

        if (response.status === 200) {
            setCtx((ctx) => ({
                ...ctx,
                paymentProgress: response.data,
            }));

            if (response.data.Status?.COMPLETE) {
                const paymentReference = response.data.paymentData?.payment?.id
                completePayment(paymentReference);
            }
        }
    }

    const resetPayment = async () => {
        setCtx(ctx => ({
            ...ctx,
            state: "buying",
            paymentProgress: undefined,
            isPaying: false,
            transferSuccessful: false
        }));
        return;
    }

    const [ctx, setCtx] = useState<IAppContext>({
        updateCart,
        startPayment,
        completePayment,
        updatePaymentProgress,
        resetPayment,
        paymentProgress: undefined,
        order: undefined,
        cartID: undefined,
        cart: undefined,
        error: undefined,
        state: "buying",
        isPaying: false,
        transferSuccessful: false
    })

    return (
        <AppContext.Provider value={{...ctx, completePayment, startPayment, updatePaymentProgress, updateCart}}>
            {children}
        </AppContext.Provider>
    )
}

export default CartProvider;
